import { HandleSSOCallback } from '@clerk/react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { loginTaskPath } from '@/lib/auth/login-session';
import { safeLocalPath } from '@/lib/auth/onboarding-intent';

/**
 * OAuth return handler for the custom login flow (`signIn.sso`).
 * Mounted at `/login/sso-callback` under the `/login/*` route.
 */
export function LoginSsoCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const next = searchParams.get('next') ?? undefined;
  const redirectUrl = safeLocalPath(next, '/trips/active');

  return (
    <HandleSSOCallback
      navigateToApp={({ session, decorateUrl }) => {
        const destination = decorateUrl(
          session?.currentTask ? loginTaskPath(session.currentTask.key, redirectUrl) : redirectUrl,
        );
        if (destination.startsWith('http')) {
          window.location.href = destination;
          return;
        }
        navigate(destination, { replace: true });
      }}
      navigateToSignIn={() => {
        const query = next ? `?next=${encodeURIComponent(next)}` : '';
        navigate(`/login${query}`, { replace: true });
      }}
      navigateToSignUp={() => {
        const query = next ? `?next=${encodeURIComponent(next)}` : '';
        navigate(`/login${query}`, { replace: true });
      }}
    />
  );
}
